import React, { useState } from 'react';
import config from '../config';
import { login } from '../contexts/loginContexts';
import { fetchAndCacheMenuItems } from '../services/menuCache';
import { storeAuthSession } from '../utils/authUser';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const payload = {
      username: formData.email,
      password: formData.password,
    };

    try {
      const response = await login(`${config.baseurl}Auth/login`, payload);
      console.log("response", response);
      if (response?.status === 200) {
        const storedUser = storeAuthSession(response.data);
        try {
          await fetchAndCacheMenuItems(storedUser?.userId || response.data.user?.userId);
        } catch (e) {
          // Menu will be fetched by Sidebar hook if this fails.
        }
        window.location.href = '/dashboard';
      } else {
        setError(response?.message || 'Invalid credentials');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow dark:bg-gray-800 dark:border dark:border-gray-700">

        {/* Logo */}
        <div className="flex justify-center pt-6">
          <img
            src="/maillogo.png"   // from public folder
            alt="Company Logo"
            className="h-14"
          />
        </div>

        <div className="p-6 space-y-6">
          <h1 className="text-2xl font-semibold text-center text-gray-900 dark:text-white">
            Sign in to your account
          </h1>

          {error && (
            <div className="text-sm text-red-600 bg-red-100 px-3 py-2 rounded">
              {error}
            </div>
          )}

          <form onSubmit={handleLogin} className="space-y-4">

            {/* Email */}
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="name@company.com"
                className="w-full rounded-lg border border-gray-300 p-2.5 text-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              />
            </div>

            {/* Password */}
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300">
                Password
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="••••••••"
                className="w-full rounded-lg border border-gray-300 p-2.5 text-sm focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              />
            </div>

            {/* Remember + Forgot */}
            <div className="flex items-center justify-between text-sm">
              {/* <label className="flex items-center gap-2 text-gray-600 dark:text-gray-300">
                <input
                  type="checkbox"
                  name="rememberMe"
                  checked={formData.rememberMe}
                  onChange={handleChange}
                  className="rounded border-gray-300"
                />
                Remember me
              </label> */}

              <a
                href="/forgot-password"
                className="text-primary-600 hover:underline"
              >
                Forgot password?
              </a>
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-lg bg-primary-600 py-2.5 text-sm font-medium text-white hover:bg-primary-700 focus:ring-4 focus:ring-primary-300 disabled:opacity-60"
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </button>

          </form>
        </div>
      </div>
    </section>
  );
};

export default Login;
